// Schema field generators for button slots.
// Kept separate from @/lib/theme/button-fields so that schema files can be
// loaded by admin-dashboard's Vite without resolving the @/ alias.
//
// Each helper returns a single `object`-type field so the builder renders
// all sub-fields as a visually grouped block with a live button preview.

export function primaryButtonFields(slotKey: string, label: string) {
  return [
    {
      key: slotKey,
      label,
      type: 'object' as const,
      preview: { type: 'button' as const, variant: 'primary' as const, defaultLabel: label },
      fields: [
        { key: 'label', label: 'Button Text', type: 'string' as const },
        { key: 'bg', label: 'Background Color', type: 'color' as const },
      ],
    },
  ];
}

export function outlineButtonFields(slotKey: string, label: string) {
  return [
    {
      key: slotKey,
      label,
      type: 'object' as const,
      preview: { type: 'button' as const, variant: 'outline' as const, defaultLabel: label },
      fields: [
        { key: 'label', label: 'Button Text', type: 'string' as const },
        { key: 'bg', label: 'Background Color', type: 'color' as const },
      ],
    },
  ];
}
